var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1C20 0.447715 19.5523 -6.61321e-07 19 -2.39852e-07L10 -4.50586e-07C9.44772 -4.50586e-07 9 0.447715 9 1C9 1.55228 9.44772 2 10 2L18 2L18 10C18 10.5523 18.4477 11 19 11C19.5523 11 20 10.5523 20 10L20 1ZM11.7071 9.70711L19.7071 1.70711L18.2929 0.292893L10.2929 8.29289L11.7071 9.70711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.39852e-07 19C-6.61321e-07 19.5523 0.447715 20 1 20L10 20C10.5523 20 11 19.5523 11 19C11 18.4477 10.5523 18 10 18L2 18L2 10C2 9.44772 1.55228 9 1 9C0.447715 9 -4.50586e-07 9.44772 -4.50586e-07 10L-2.39852e-07 19ZM8.29289 10.2929L0.292893 18.2929L1.70711 19.7071L9.70711 11.7071L8.29289 10.2929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrow);
export default __webpack_public_path__ + "static/media/ExpandArrow.eb90640a9f55b529b5484771d40274bf.svg";
export { ForwardRef as ReactComponent };